export default __webpack_public_path__ + "static/RobotoMono-Italic-973167872e4dedc67dff2eb77e981825.woff";